import View from 'scripts/poppet/view';
import template from 'templates/unitNativeChoiceView.jst.html'

const selectors = {
	buttonBluetooth: '[data-click=native-bluetooth]',
	buttonSearch   : '[data-click=native-search]',
};

/**
 * defa.views.UnitNativeChoiceView
 * A view to select either bluetooth scan or serial number.
 * @version 1.0.1
 */

const UnitNativeChoiceView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		bluetooth: selectors.buttonBluetooth,
		search   : selectors.buttonSearch,
	},
	
	events: {
		'click @ui.bluetooth': 'onClickBluetooth',
		'click @ui.search'   : 'onClickSearch',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the user clicks the bluetooth button.
	 * @void
	 */
	onClickBluetooth: function () {
		this.trigger( 'nav', 'unit:bluetooth' );
	},
	
	/**
	 * Triggers when the user clicks the search button.
	 * @void
	 */
	onClickSearch: function () {
		this.trigger( 'nav', 'unit:search:serial' );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	
} );

export default UnitNativeChoiceView;